export default "__VITE_ASSET__BDy9p7Xf__"